import * as ajax from '../ajax/ajax'
import {USER_AUTHENTICATED_PATH} from '../ajax/sdgOnlinePaths'

const handleResponse = (response) => {
  return {data: response.data};
}

const handleError = (error) => {
  // if its a 401, they aren't logged in, but since we don't want to show an error message, we'll return an object
  //with undefined data
  if (error.request) {
    if (error.status === 401) {
      return {data : null};
    }
    throw error.request;
  }
  throw error;
};


export default class UserApi {

  static getUserDetails() {
    return ajax.getJson(USER_AUTHENTICATED_PATH).then(handleResponse, handleError);
  }

}